import {
  FieldHtmlNameUtil,
  HekateOptionListDisplayElement,
} from 'www-shared';

import FormFieldCoordinator from './FormFieldCoordinator';

export default class SelectFieldCoordinator extends FormFieldCoordinator {
  /**
   * This watches change to the country field so that the `state` field can be switched out to be a select field of states/provinces for US/Canada.
   *
   * AND
   *
   * returns an ordered list with the countries in a way for easy choice for high ARR countries (e.g. US, Canada, Germany, etc...)
   */
  private handleCountries() {
    const { optionList } = this.field.value;
    const firstPickCountries: string[] = ['United States', 'United Kingdom', 'Canada', 'Australia', 'Germany', 'Switzerland'];
    return firstPickCountries
      .filter((country) => optionList.elements.find((elm: { value: string; }) => elm.value === country))
      .map((country) => {
        const found = optionList.elements.find((elm: { value: string; }) => elm.value === country);
        if (found === undefined) {
          // what should we do with this error?
          throw new Error(`could not find option in option list:${country}`);
        }
        return new HekateOptionListDisplayElement(found);
      });
  }

  /** Build the options list putting "first" picks at the top of the list. */
  private buildOptionListWithFirstPicks() {
    const { optionList, htmlName } = this.field.value;

    let firstPicks: HekateOptionListDisplayElement[] = [];

    switch (htmlName) {
      case FieldHtmlNameUtil.country:
      case FieldHtmlNameUtil.maxCountry:
        firstPicks = this.handleCountries();
        break;
      default:
        return optionList.elements.map((elm: { value: string; displayName: string; isOptGroup?: boolean | undefined; }) => new HekateOptionListDisplayElement(elm));
    }

    // Rebuild pick list based on if there are any "firstPicks"
    const emptySelection = optionList.elements.find((elm: { value: string; }) => elm.value === '');
    const allOptions: HekateOptionListDisplayElement[] = [];
    if (emptySelection) {
      allOptions.push(new HekateOptionListDisplayElement(emptySelection));
    }
    firstPicks.forEach((elm) => allOptions.push(elm));
    allOptions.push(new HekateOptionListDisplayElement({
      displayName: '———————',
      value: '',
      isOptGroup: true,
    }));

    optionList.elements
      .filter((elm: { value: string; }) => elm.value !== '')
      .forEach((elm: { value: string; displayName: string; isOptGroup?: boolean | undefined; }) => allOptions.push(new HekateOptionListDisplayElement(elm)));

    return allOptions;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  public setup() {
    return {
      bubbleModel: this.buildBubbleModel(),
      allOptions: this.buildOptionListWithFirstPicks(),
    };
  }
}
